export namespace LivenessDetectionConstants {

    export const PROFILING = false;
    export const STATE_AREA_DURATION_IN_SECONDS = 25;
    export const STATE_NOSE_DURATION_IN_SECONDS = 20;
    export const MAX_FPS = 12;
    export const FACE_AREA_TOLERANCE_PERCENT = 75; // 15
    export const LANDMARK_NOSE_INDEX = 30;
    export const IMAGE_JPG_QUALITY = 0.7;
}